"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectModelUtil = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
class ProjectModelUtil {
    constructor(projectModel) {
        this.projectModel = projectModel;
    }
    getModulePinPosition(moduleRef, pinRef) {
        const [design, module] = this.getDesignModuleByRef(moduleRef);
        if (design.modelType !== 'schematic') {
            throw new Error(`Module ${moduleRef} is not in a schematic design`);
        }
        const component = this.projectModel.components[module.componentRef];
        if (!component) {
            throw new Error(`Component ${module.componentRef} not found for module ${module.name}`);
        }
        const footprint = component[design.modelType === 'schematic' ? 'symbols' : 'footprints'].find((f) => f.ref === module.footprintRef);
        if (!footprint) {
            throw new Error(`${design.modelType === 'schematic' ? 'Symbol' : 'Footprint'} ${module.footprintRef} not found for module ${module.name}`);
        }
        if ('pins' in footprint) {
            const pin = footprint.pins.find((p) => p.ref === pinRef);
            if (!pin) {
                throw new Error(`Pin ${pinRef} not found in symbol ${footprint.ref}`);
            }
            let transformedStart = sigma_engine_shared_1.Utils.Transform.rotatePoint(pin.start, -(module.transform.angle ?? 0));
            let transformedEnd = sigma_engine_shared_1.Utils.Transform.rotatePoint(pin.end, -(module.transform.angle ?? 0));
            if (module.transform.mirrored) {
                transformedStart = sigma_engine_shared_1.Utils.Transform.getXyWithMirror(transformedStart, module.transform.mirrored);
                transformedEnd = sigma_engine_shared_1.Utils.Transform.getXyWithMirror(transformedEnd, module.transform.mirrored);
            }
            const center = sigma_engine_shared_1.Utils.Transform.getXyWithMirror(sigma_engine_shared_1.Utils.Transform.rotatePoint([0, 0], -(module.transform.angle ?? 0), module.transform.pos ?? [0, 0]), module.transform.mirrored);
            const offset = [center[0] + (module.center?.[0] ?? 0), center[1] + (module.center?.[1] ?? 0)];
            transformedStart = sigma_engine_shared_1.Utils.Transform.translatePoint(transformedStart, offset);
            transformedEnd = sigma_engine_shared_1.Utils.Transform.translatePoint(transformedEnd, offset);
            return {
                start: transformedStart,
                end: transformedEnd,
            };
        }
        else {
            throw new Error(`Footprint ${footprint.ref} is not a schematic footprint`);
        }
    }
    getComponentSymbolByRef(componentRef, footprintRef) {
        const component = this.projectModel.components[componentRef];
        if (!component) {
            throw new Error(`Component ${componentRef} not found`);
        }
        const symbol = component.symbols.find((s) => s.ref === footprintRef);
        if (!symbol) {
            throw new Error(`Symbol ${footprintRef} not found for component ${component.name}`);
        }
        return { component, symbol };
    }
    getDesignModuleByRef(moduleRef) {
        for (const design of Object.values(this.projectModel.designs)) {
            const module = design.modules.find((m) => m.ref === moduleRef);
            if (module) {
                return [design, module];
            }
        }
        throw new Error(`Module ${moduleRef} not found in any design`);
    }
}
exports.ProjectModelUtil = ProjectModelUtil;
//# sourceMappingURL=ProjectModelUtil.js.map